import { useWebTranslation } from "translations";
import { Typography } from "ui-kit/Typography";
import { TypographyVariant } from "ui-kit/Typography/types";
import { YEARLY_BILLING_INTERVAL } from "utils/insurance";
import { AmountToPay } from "utils/insurance/getAmountToPay";
import { DiscountType } from "../../../../../__generated__/globalTypes";

export const getDiscountDisclaimerTranslationKey = ({
  duration,
  type,
}: {
  duration: number;
  type: DiscountType;
}) => {
  if (type === DiscountType.MultiPet) {
    return "discounts.valid_for_multipet";
  }

  switch (duration) {
    case 1:
      return "discounts.valid_for_one_month";
    case 12:
      return "discounts.valid_for_first_year";

    default:
      return "discounts.valid_for_x_months";
  }
};

const getYearlyDiscountDisclaimer = (type: DiscountType) => {
  if (type === DiscountType.MultiPet) {
    return "discounts.valid_for_multipet";
  }

  return "discounts.valid_for_first_year";
};

export const DiscountDisclaimer = ({
  fee,
  alignText = "left",
  variant = TypographyVariant.body3,
  billingInterval,
}: {
  fee: AmountToPay["fees"][number] | null;
  alignText?: "left" | "center" | "right";
  variant?: TypographyVariant;
  billingInterval: number;
}) => {
  const { t } = useWebTranslation();

  return fee ? (
    <Typography variant={variant} color="grey400" align={alignText}>
      {billingInterval === YEARLY_BILLING_INTERVAL
        ? t(getYearlyDiscountDisclaimer(fee.discountType))
        : t(
            getDiscountDisclaimerTranslationKey({
              duration: fee.maxInvoicesSpread,
              type: fee.discountType,
            }),
            {
              months: fee.maxInvoicesSpread,
            }
          )}
    </Typography>
  ) : null;
};
